export default "__VITE_ASSET__BTKcsOIo__"